var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("background-position: 50% calc(50% + " + _vm.offset + "px);"))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }